import React from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { AdSlot } from "./ads/AdSlot";

interface GameShellProps {
  left: React.ReactNode;
  right: React.ReactNode;
}

export const GameShell: React.FC<GameShellProps> = ({ left, right }) => {
  return (
    <div className="page-shell">
      <Header />
      <main className="page-main" role="main">
        <section
          aria-label="Puzzle gameplay"
          className="card shadow-soft scroll-y-soft"
        >
          <div style={{ padding: "0.75rem", paddingBottom: "0.4rem" }}>
            <AdSlot
              id="banner-top"
              label="Banner Ad"
              description="Your sponsor banner will appear here without blocking the puzzle."
              size="banner"
            />
          </div>
          <div
            style={{
              padding: "0.75rem",
              paddingTop: "0.25rem",
              paddingBottom: "0.8rem"
            }}
          >
            {left}
          </div>
        </section>

        <aside
          aria-label="Multiplayer lobby and stats"
          className="card shadow-soft scroll-y-soft"
        >
          <div style={{ padding: "0.75rem", paddingBottom: "0.4rem" }}>
            <AdSlot
              id="sidebar-1"
              label="Sidebar Ad"
              description="Static ad slot visible alongside the lobby and results."
            />
          </div>
          <div
            style={{
              padding: "0.75rem",
              paddingTop: "0.25rem",
              paddingBottom: "0.85rem"
            }}
          >
            {right}
          </div>
        </aside>
      </main>
      <Footer />
    </div>
  );
};


